import './FieldButtonStyleReset.css';

import { cn } from '##/utils/bem';

export const cnFieldButtonStyleReset = cn('FieldButtonStyleReset');
